import { NeoColor, Skeleton, Stack } from "@noom/wax-component-library";

/**
 * Skeleton sized to match `TreatmentDetailReadyContent`'s real layout —
 * treatment-name line, product lockup band, and a short list of action
 * link rows. Replaces the prior reuse of `TreatmentCardSkeleton`, which
 * is card-shaped and looked out of place on a single-treatment detail
 * page.
 */
export const TreatmentDetailSkeleton = () => (
  <Stack
    width="100%"
    pt={2}
    spacing={3}
    alignItems="stretch"
    data-testid="treatment-detail-skeleton"
  >
    {/* Treatment name */}
    <Skeleton
      height={6}
      width="60%"
      borderRadius="md"
      startColor={NeoColor.greyscale.gray1}
      endColor={NeoColor.greyscale.lightGray}
    />
    {/* Product lockup */}
    <Skeleton
      height="100px"
      width="100%"
      borderRadius="10px"
      startColor={NeoColor.greyscale.gray1}
      endColor={NeoColor.greyscale.lightGray}
    />
    {/* Action link rows */}
    <Stack spacing={2} pt={4}>
      {[0, 1, 2, 3].map((i) => (
        <Skeleton
          key={i}
          height={6}
          width="100%"
          borderRadius="md"
          startColor={NeoColor.greyscale.gray1}
          endColor={NeoColor.greyscale.lightGray}
        />
      ))}
    </Stack>
  </Stack>
);
